// userobj是用户自己归属的数据 只需要在用户自己的多端设备间进行同步

import {DB, ExecuteResult} from './index';
import time from '../time';

const upsert_sql =
    'insert into t_userobj(res_id, res_type, data, attr, utime, lutime, lctime)' +
    ' values(?, ?, ?, ?, ?, ?, ?)' +
    ' ON CONFLICT(res_id, res_type) DO UPDATE SET' +
    ' data=?, attr=?, utime=?, lutime=?';

// 插入或者更新用户对象
export async function userobj_upsert(
    db: DB,
    userObj: UserObj,
): Promise<ExecuteResult> {
    const d = UserObjToEntity(fixUserObj(userObj));
    const timeUnix = time.toUnixMillSecond(time.now());
    d.lctime = timeUnix;
    d.lutime = timeUnix;
    const params = [];
    params.push(
        ...[d.res_id, d.res_type, d.data, d.attr, d.utime, d.lutime, d.lctime],
    );
    params.push(...[d.data, d.attr, d.utime, d.lutime]);
    return await db.Execute(upsert_sql, params);
}

export async function userobj_query_one(
    db: DB,
    res_id: string,
    res_type: string,
): Promise<{error: any; userobj?: UserObj}> {
    const sql = 'select * from t_userobj where res_id=? and res_type=? limit 1';
    const r = await db.Query(sql, [res_id, res_type]);
    if (r.error) {
        return {error: r.error};
    }

    if (!(r.data && r.data.length > 0)) {
        return {error: null};
    }
    const d = r.data[0] as Entity;
    return {error: null, userobj: EntityToUserObj(d)};
}

// 用户对象转数据库实体
function UserObjToEntity(u: UserObj): Entity {
    const d: Entity = {
        res_id: u.resId,
        res_type: u.resType,
        data: u.data,
        attr: JSON.stringify(u.attr),
        utime: u.utime,
        lutime: u.lutime,
        lctime: u.lctime,
    };
    return d;
}

// 数据库实体转用户对象
function EntityToUserObj(d: Entity): UserObj {
    const u: UserObj = {
        resId: d.res_id,
        resType: d.res_type,
        data: d.data,
        attr: JSON.parse(d.attr),
        utime: d.utime,
        lutime: d.lutime,
        lctime: d.lctime,
    };
    return u;
}

export type Attr = {[key: string]: string};

// UserObject 用户自定义的数据
export type UserObj = {
    resId: string;
    resType: string;
    data: string;
    attr: Attr; // 属性字段
    utime: number; // 更新时间
    lutime: number; // 本地记录最后更新时间
    lctime: number; // 本地记录最后创建时间
};

const defaultUserObj = {
    resId: '', // res_id res_type联合主键
    resType: '', // res_id res_type联合主键
    data: '',
    attr: {}, // 属性字段
    lutime: 0, // 本地记录最后更新时间
    lctime: 0, // 本地记录最后创建时间
};

function fixUserObj(d: UserObj): UserObj {
    return Object.assign({}, defaultUserObj, d);
}

type Entity = {
    res_id: string; // res_id res_type联合主键
    res_type: string; // res_id res_type联合主键
    data: string;
    attr: string; // 属性字段
    utime: number; // 服务端给的修改时间
    lutime: number; // 本地记录最后更新时间
    lctime: number; // 本地记录最后创建时间
};

/*
drop table if exists t_userobj;
create table t_userobj(res_id, res_type, data, attr, lutime, lctime,  primary key(res_id,res_type));
 */

// 目前拥有的userobj类型
export type UserObjType =
    | 'friend_apply' // 新的好友申请数量，事件通知即可，数据本地有在userobj里存
    | 'friend_rel' // 好友关系 add 增加  delete 删除
    // | 'friend_request' // 没用；后台存储使用的，没有发布到前台
    | 'topic_delete'
    | 'topic_mute'
    | 'topic_remark'
    | 'topic_to_top'
    | 'topic_visit'
    | 'user_head'
    | 'user_remark';
